import React, { useContext, useState, useEffect, useMemo } from "react";
import {
  Form,
  Select,
  Card,
  Row,
  Col,
  // Switch,
  // Typography,
  // Tooltip,
  // Divider,
} from "antd";
import { UserInfoContext } from "../../../../../Context/CommonContext";
import useMasterContext from "../../../../../Context/MasterContext";
import { useGetApi } from "../../../../../utilFunctions/CustomHooks/useGetAPI";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
// import InfoIcon from "Assets/Icons/InfoIcon";

// const { Text } = Typography;

const TargetBatches = ({
  batchInfo,
  form,
  selectedPost,
  initialBatchOptions = [],
}: any) => {
  const userInfo = useContext<any>(UserInfoContext);
  const { masters } = useMasterContext();
  const PostType = selectedPost?.postType || form.getFieldValue("postType");

  const [stateOptions, setStateOptions] = useState<any[]>([]);
  const [branchOptions, setBranchOptions] = useState<any[]>([]);
  const [batchOptions, setBatchOptions] = useState<any[]>([]);

  const [selectedState, setSelectedState] = useState<any>(null);
  const [selectedBranch, setSelectedBranch] = useState<any>(null);
  const [selectedStream, setSelectedStream] = useState<any>(null);
  const [selectedClass, setSelectedClass] = useState<any>(null);

  const selectedBatches = Form.useWatch("batchIds", form) || [];
  const { makeRequest: fetchBatches, loading: batchesLoading } = useGetApi(
    (data) => {
      console.log("batches data", data);
      if (data && data?.data) {
        const batchData = data?.data.map((batch: any) => ({
          label: batch.batchName,
          value: batch.id,
        }));
        setBatchOptions([...batchData]);
      } else {
        setBatchOptions([]);
      }
    },
    (error) => {
      setBatchOptions([]);
      console.error(error);
    }
  );

  const allBatchOptions = useMemo(() => {
    const options = batchInfo
      ? [batchInfo, ...initialBatchOptions, ...batchOptions]
      : [...initialBatchOptions, ...batchOptions];
    const uniqueOptions = options.reduce((acc: any[], current: any) => {
      if (current && !acc.find((item: any) => item.value === current.value)) {
        acc.push(current);
      }
      return acc;
    }, []);
    return uniqueOptions;
  }, [batchInfo, batchOptions, initialBatchOptions]);

  const regionOptions = useMemo(() => {
    if (!userInfo?.region || !masters?.regions) return [];
    const userAllotedRegiondata = userInfo.region.split(",");
    return masters.regions
      .filter((item: any) => userAllotedRegiondata.includes(String(item.id)))
      .map((item: any) => ({
        id: item.id,
        key: item.id,
        label: item.label,
        value: item.regionCode,
      }));
  }, [userInfo?.region, masters?.regions]);

  const streamOptions = useMemo(() => {
    return userInfo?.userStreams || [];
  }, [userInfo?.userStreams]);

  const classOptions = useMemo(() => {
    return (
      masters?.classes.map((item: any) => ({
        value: item.label,
        label: item.label,
      })) || []
    );
  }, [masters?.classes]);

  useEffect(() => {
    if (selectedStream && selectedBranch && selectedClass) {
      const streamLabel = streamOptions.find(
        (s: any) => s.value == selectedStream
      )?.label;
      const url =
        BASE_URL +
        "batch/search" +
        `?stream=${streamLabel}&branchCode=${selectedBranch}&month=9&year=25&sortBy=testDate&sortDir=ASC&clazz=${selectedClass}`;
      fetchBatches(url);
    } else {
      setBatchOptions([]);
    }
  }, [selectedStream, selectedBranch, selectedClass]);

  const handleRegionChange = (value: any) => {
    const region = masters?.regions.find(
      (item: any) => item.regionCode === value
    );
    if (region && masters?.states) {
      const filteredItems = masters.states.filter(
        (item: any) =>
          region.otherMapping.includes(item.value) &&
          userInfo?.stateIds.includes(item.id)
      );
      setStateOptions(filteredItems);
    } else {
      setStateOptions([]);
    }
    setSelectedState(null);
    form.setFieldValue("state", null);
    setSelectedBranch(null);
    form.setFieldValue("branch", null);
    setBranchOptions([]);
    setBatchOptions([]);
  };

  const handleStateChange = (value: any) => {
    setSelectedState(value);
    const filteredbranches: any = [];
    masters?.userAssignedBranches.forEach((item: any) => {
      if (item.otherMapping === value) {
        filteredbranches.push(item);
      }
    });
    setBranchOptions(filteredbranches);
    setSelectedBranch(null);
    form.setFieldValue("branch", null);
    setBatchOptions([]);
  };

  return (
    <Card title="Target Batches">
      <Row gutter={16}>
        <Col xs={12} sm={12} md={6} lg={4} xl={4}>
          <Form.Item name="stream">
            <Select
              placeholder="Stream"
              options={streamOptions}
              onChange={(value) => setSelectedStream(value)}
            />
          </Form.Item>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} xl={4}>
          <Form.Item name="class">
            <Select
              placeholder="Class"
              options={classOptions}
              onChange={(value) => setSelectedClass(value)}
            />
          </Form.Item>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} xl={4}>
          <Form.Item name="region">
            <Select
              placeholder="Region"
              onChange={handleRegionChange}
              options={regionOptions}
            />
          </Form.Item>
        </Col>
        <Col xs={12} sm={12} md={6} lg={4} xl={4}>
          <Form.Item name="state">
            <Select
              placeholder="State"
              onChange={handleStateChange}
              value={selectedState}
              options={stateOptions}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Form.Item name="branch">
            <Select
              allowClear
              mode="multiple"
              placeholder="Branch"
              options={branchOptions}
              onChange={(value) => setSelectedBranch(value)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        name="batchIds"
        rules={[{ required: true, message: "Please select batches!" }]}
        label="Select batches to publish to..."
      >
        <Select
          mode="multiple"
          placeholder="Select batches"
          options={allBatchOptions}
          loading={batchesLoading}
        />
      </Form.Item>
      {PostType == "POST" && selectedBatches.length > 0 && (
        <>
          {/* <div style={{ marginTop: 16 }}> */}
          {/* <Divider />
            <Tooltip title="Allow students to comment on the post">
              <Text>
                Comment Allowed <InfoIcon />
              </Text>
            </Tooltip> */}
          {/* <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Form.Item
                name="commentAllowed"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Switch />
              </Form.Item>
            </div> */}
          {/* </div> */}
          {/* 
          <div style={{ marginTop: 16 }}>
            <Divider />
            <Tooltip title="Allow students to see each other comments">
              <Text>
                Comment Visibility <InfoIcon />
              </Text>
            </Tooltip>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <span>Allow students to see each other&apos; comments</span>
              <Form.Item
                name="commentVisibility"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Switch />
              </Form.Item>
            </div>
          </div> */}
        </>
      )}
    </Card>
  );
};

export default TargetBatches;
